import { Loader2 } from "lucide-react";

/** Shown while a lazy-loaded module chunk is downloading / mounting */
export function ModuleSuspenseFallback() {
  return (
    <div className="flex min-h-[40vh] flex-1 flex-col items-center justify-center gap-2 text-muted-foreground">
      <Loader2 className="h-8 w-8 animate-spin" aria-hidden />
      <span className="text-sm">Cargando módulo…</span>
    </div>
  );
}
